import { Controller } from "@hotwired/stimulus"
import { browserTimeZone, sameOffset, wallClock } from "../helpers/time_zones"

// Public pages show the specialist's clock. When the visitor's device is in
// another zone, each time gets the local equivalent next to it.
export default class extends Controller {
  static targets = ["time", "note", "zone"]
  static values = { zone: String, prefix: { type: String, default: "у вас" } }

  connect() {
    const browser = browserTimeZone()
    if (!browser || sameOffset(this.zoneValue, browser)) return
    this.timeTargets.forEach((element) => this.annotate(element, browser))
    if (this.hasZoneTarget) this.zoneTarget.textContent = browser
    if (this.hasNoteTarget) this.noteTarget.hidden = false
  }

  annotate(element, browser) {
    if (element.querySelector(".zone-time__local")) return
    const iso = element.getAttribute("datetime")
    const date = iso ? new Date(iso) : null
    if (!date || Number.isNaN(date.getTime())) return
    const otherDay = wallClock(date, browser, true).slice(0, 5) !== wallClock(date, this.zoneValue, true).slice(0, 5)
    const local = wallClock(date, browser, otherDay)
    if (!local) return
    const span = document.createElement("span")
    span.className = "zone-time__local"
    span.textContent = ` · ${this.prefixValue} ${local}`
    element.appendChild(span)
  }
}
